import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Module } from 'src/app/core/interfaces/module.interface';
import { Page } from 'src/app/core/interfaces/page.interface';
import { environment } from 'src/environments/environment';
import { Filter } from '../interfaces/filter.interface';

@Injectable({
  providedIn: 'root',
})
export class ModulesService {
  private baseUrl = environment.adminApiBaseUrl;
  private moduleApiUrl = `${this.baseUrl}/Module`;

  private pageApiUrl = `${this.baseUrl}/Page`;

  constructor(private http: HttpClient, private router: Router) { }

  getModuleById = (id: number): Observable<any> => {
    return this.http.get(this.moduleApiUrl + '/' + id);
  }

  listModules = (PageNumber = 1, PageSize = 10, Term = '', filters?: Filter[]): Observable<any> => {
    const params = {
      PageNumber,
      PageSize,
      Term,
      advancedFilter: filters,
    };
    return this.http.post(`${this.moduleApiUrl}/List`, params);
  }

  myModules = (): Observable<any> => {
    return this.http.get(`${this.moduleApiUrl}/my-modules`);
  }

  createModule(data: Module): Observable<any> {
    return this.http.post(this.moduleApiUrl, data);
  }

  updateModule(data: Module): Observable<any> {
    return this.http.put(this.moduleApiUrl, data);
  }

  deleteModule(id: number): Observable<any> {
    return this.http.delete(this.moduleApiUrl + '/' + id);
  }

  getPage(id: number): Observable<any> {
    return this.http.get(this.pageApiUrl + '/' + id);
  }

  getAllPage(): Observable<any> {
    return this.http.get(this.pageApiUrl);
  }

  listPages = (PageNumber = 1, PageSize = 10, Term = '', filters?: Filter[]): Observable<any> => {
    const params = {
      PageNumber,
      PageSize,
      Term,
      advancedFilter: filters,
    };
    return this.http.post(`${this.pageApiUrl}/List`, params);
  }

  createPage(data: Page): Observable<any> {
    return this.http.post(this.pageApiUrl, data);
  }

  updatePage(data: Page): Observable<any> {
    return this.http.put(this.pageApiUrl, data);
  }

  deletePage(id: number): Observable<any> {
    return this.http.delete(this.pageApiUrl + '/' + id);
  }

  getPageActions(): Observable<any> {
    return this.http.get(this.pageApiUrl + '/actions');
  }
}
